import AnimatedRow from '@kiosk/common/components/Forms/AnimatedRow';
import RowIcon from '@kiosk/common/components/Forms/RowIcon';
import RowContent from '@kiosk/common/components/Forms/RowContent';
import Label from '@kiosk/common/components/Text/Label';
import ContentText from '@kiosk/common/components/Text/ContentText';

type Props = { icon: string; label: string; contentTxt: string; delay: number };

const TimesheetEntryBaseRow = ({ icon, label, contentTxt, delay }: Props) => (
  <AnimatedRow borderTop={false} borderBottom delay={delay}>
    <RowIcon src={icon} />
    <RowContent>
      <Label>{label}</Label>
      <ContentText>{contentTxt}</ContentText>
    </RowContent>
  </AnimatedRow>
);

export default TimesheetEntryBaseRow;
